import React, { useEffect, useState } from 'react';
import { Message, Spin } from '@arco-design/web-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiAuthorLogin } from '@/api/system';
import { login } from '@/utils/auth';
import { useOrg } from '@/utils/hooks/useOrg';
import { useMemoizedFn } from 'ahooks';
import styles from './DingTalkCallback.module.less';

const DingTalkCallback: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { orgId } = useOrg();

  const navigateToHome = useMemoizedFn(() => {
    const redirectUrl = searchParams?.get('redirect');
    const defaultPath = `/org/${orgId}/`;
    try {
      const decodeUrl = redirectUrl
        ? decodeURIComponent(redirectUrl)
        : undefined;
      navigate(decodeUrl || defaultPath, { replace: true });
    } catch (e) {
      navigate(defaultPath, { replace: true });
    }
  });

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get('code');
      const corpId = searchParams.get('corp_id');

      if (!code || !corpId) {
        setError('授权参数缺失');
        setLoading(false);
        return;
      }

      try {
        const { token } = await apiAuthorLogin({ code });
        if (token) {
          login(token);
          Message.success('钉钉登录成功');
          navigateToHome();
        } else {
          setError('登录失败，未获取到token');
          setLoading(false);
        }
      } catch (error) {
        console.error('钉钉登录失败:', error);
        setError('钉钉登录失败，请重试');
        setLoading(false);
      }
    };

    handleCallback();
  }, [searchParams, navigateToHome]);

  if (error) {
    return (
      <div className={styles.callbackContainer}>
        <div className={styles.errorContent}>
          <div className={styles.errorIcon}>❌</div>
          <div className={styles.errorText}>{error}</div>
          <button
            className={styles.retryButton}
            onClick={() => (window.location.href = `/org/${orgId}/login`)}
          >
            返回登录页
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.callbackContainer}>
      <div className={styles.loadingContent}>
        <Spin size={40} />
        <div className={styles.loadingText}>正在处理钉钉授权...</div>
      </div>
    </div>
  );
};

export default DingTalkCallback;
